import React,{useEffect} from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import AuthenticatedLayout from "./AuthenticatedLayout";
import OTPScreen from "./pages/credentials/OTPScreen";
import SetPassword from "./pages/credentials/SetPassword";
import {
  CreateAccount,
  Login,
  ForgotPassword,
  CreatePassword,
  ChangePassword,
  Dashboard,
  ClientManagement,
  ClientDetails,
  InvestmentSchedules,
  Settings,
  HelpAndSupport,
  NewProfile,
  Profile,
  TwoFactorOTP,
  EditProfile,
} from "./pages";
import CreateNewAnalysisPage from "./pages/investmentSchedules/CreateNewAnalysisPage";
import ViewAnalysisPage from "./pages/investmentSchedules/ViewAnalysisPage";
import EditAnalysisPage from "./pages/investmentSchedules/EditAnalysisPage";
import "./App.scss";
import SessionTimeout from "./components/SessionTimeout";
import EngagementSetup from "./pages/dashboard/EngagementSetup/EngagementSetup";
import { AuthProvider, useAuth } from "./AuthProvider";
import { SubscriptionProvider } from "./SubscriptionContext"; // Import the Subscription Provider
import ProtectedRoute from "./ProtectedRoute";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DocumentSummary from "./pages/dashboard/EngagementSetup/DocumentSummary/DocumentSummary";

// Wrapper component that uses the auth hook for SessionTimeout
const AppContent = () => {
  const { isUserLoggedIn, logout } = useAuth();
useEffect(() => {
  const navEntries = performance.getEntriesByType("navigation");
  const navType = navEntries.length > 0 ? navEntries[0].type : "navigate";

 if (navType === "back_forward") {
  const sessionToken = sessionStorage.getItem("authToken");
  const localToken = localStorage.getItem("authToken");

  if (!sessionToken && localToken) {
    // Request token from other tab if localToken exists
    localStorage.setItem('requestAuthToken', Date.now().toString());
    setTimeout(() => localStorage.removeItem('requestAuthToken'), 500);
  } else if (!sessionToken && !localToken) {
    // Only logout this tab (don't trigger logoutEvent)
    sessionStorage.removeItem("authToken");
    window.dispatchEvent(new Event("auth-updated"));
    window.location.reload();
  }
}

}, []);


  return (
    <>
      {isUserLoggedIn && <SessionTimeout logout={logout} />}

      <Routes>
        {/* Public Routes */}
        <Route path="/" element={isUserLoggedIn ? <Navigate replace to="/engagements" /> : <Login />} />
        <Route path="/otp-authentication" element={<TwoFactorOTP />} />
        <Route path="/request-password" element={<ForgotPassword />} />
        <Route path="/set-password" element={<SetPassword />} />
        <Route path="/create-new-account" element={<CreateAccount />} />
        <Route path="/create-password" element={<CreatePassword />} />
        <Route path="/otp-verification" element={<OTPScreen />} />
        <Route path="/create-profile" element={<NewProfile />} />

        {/* Protected Routes with AuthenticatedLayout as parent */}
        <Route element={
          <ProtectedRoute>
            <AuthenticatedLayout />
          </ProtectedRoute>
        }>
          <Route path="/engagements" element={<Dashboard />} />
          <Route path="/clients" element={<ClientManagement />} />
          <Route path="/clients/client-details/:id" element={<ClientDetails />} />
          <Route path="/investment-schedules" element={<InvestmentSchedules />} />
          <Route path="/investment-schedules/create-new-analysis" element={<CreateNewAnalysisPage />} />
          <Route path="/investment-schedules/details/:id" element={<ViewAnalysisPage />} />
          <Route path="/investment-schedules/edit/:id" element={<EditAnalysisPage />} />
          <Route path="/help-support" element={<HelpAndSupport />} />
          <Route path="/documentsummary" element={<DocumentSummary />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/edit-profile" element={<EditProfile />} />
          <Route path="/engagements/edit-engagement-setup/:id" element={<EngagementSetup />} />
          <Route path="/change-password" element={<ChangePassword />} />

          {/* Default route for authenticated users */}
          <Route path="*" element={<Navigate replace to="/engagements" />} />
        </Route>
      </Routes>
    </>
  );
};

const App = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SubscriptionProvider>
          <AppContent />
          <ToastContainer position="top-right" autoClose={3000} />
        </SubscriptionProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default App;
